import styles from "./FreightCosts.module.scss";
import {
  Checkbox,
  Col,
  Divider,
  Modal,
  Row,
  TabsProps,
  Form as FormAntd,
  message,
} from "antd";
import {
  HeaderTable,
  Tabs,
  Form,
  ModalImport,
  PermissionDirect,
} from "../../Components";
import type { HeaderTableProps } from "../../Components";
import { Setting } from "../../assets/icon";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import type { IFreightCostRow, IEditIndexItem } from "./types";
import {
  CommonApi,
  FreightCostApi,
  getPermissionRegions,
  RouteManagerApi,
  TruckVendorApi,
  getPermissionDirections,
} from "../../services";
import dayjs from "dayjs";
import { useLocation, useHistory } from "react-router-dom";
import { checkPermissions } from "../../utils/checkPermissions";
import { useRecoilValue } from "recoil";
import { UserAtom } from "../../store";
import { FreightCostListTab } from "./components/FreightCostListTab";
import { FreightCostGroupTab } from "./components/FreightCostGroupTab";
import {
  getConfigInputImportForm,
  getUpdateGroupContractorsConfig,
} from "./configs";
import {
  REQUIRED_FIELDS_GROUP,
  getAuthorizedFreightCostTab,
  getFreightCostCancelResult,
  getFreightCostListParams,
  getFreightCostPaginationAfterDelete,
  hasNullRequiredField,
  mergeFreightCostColumnsWithCurrentState,
  normalizeTouchedKey,
  setDeepImmutable,
  toPath,
  updateFreightCostColumnByDataIndex,
} from "./helpers";
import { updateColumnDisplayState } from "../../shared/helpers/tableColumns";
import { replaceRowByOriginalId } from "../../shared/helpers/rowState";
import { resetPaginationToFirstPage } from "../../shared/helpers/pagination";
import { useRequestLock } from "../../shared/hooks/useRequestLock";
import {
  canApplyFreightVersion,
  getFreightVersionOrderCount,
} from "../../shared/helpers/freightVersion";
import {
  buildLookupRequestParams,
  buildRouteBaseLookupOption,
  buildTruckVendorLookupOption,
  getLookupTablePayloadId,
  type LookupFilters,
  routeBaseLookupTable,
  truckVendorLookupTable,
} from "../../shared/lookupTables";
const { confirm } = Modal;
const { getAllRouterBase, getOneRouter } = RouteManagerApi;
const apiDebounceRoute = (
  search: string,
  _value?: string,
  filters: LookupFilters = {},
) => {
  return getAllRouterBase(buildLookupRequestParams(search, filters), {
    silentLoading: true,
  }).then((res: any) => res.data?.map(buildRouteBaseLookupOption) || []);
};
const apiDebounceTruckvendor = (
  search = "",
  _value?: string,
  filters: LookupFilters = {},
) => {
  return TruckVendorApi.getAllTruckVendorSearch(
    buildLookupRequestParams(search, filters),
  ).then((res: any) => ({
    total: res.totalItem ?? 0,
    data: res.data?.map(buildTruckVendorLookupOption) || [],
  }));
};
const FreightCosts = () => {
  // Define constant
  const history = useHistory();
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const tabs = query.get("tabs");
  const permissionState = useRecoilValue<any>(UserAtom.permissions);
  const features = permissionState?.features;
  const canEditFreightCost = checkPermissions(
    "CONTRACTOR_FREIGHT",
    "edit",
    features,
  );
  const items: TabsProps["items"] = [
    {
      key: "1",
      label: "Cước thầu phụ",
      disabled: !checkPermissions("CONTRACTOR_FREIGHT", "view", features),
    },
    {
      key: "2",
      label: "Nhóm cước thầu phụ",
      disabled: !checkPermissions("CONTRACTOR_FREIGHT_GROUP", "view", features),
    },
  ];
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [regionAndDirectionSelectOptions, setRegionAndDirectionSelectOptions] =
    useState<any>({
      direction: [],
      region: [],
    });
  // const [provines, setProvines] = useState([]);
  //constant version
  const [activeVersion, setActiveVersion] = useState<string | null>(null);
  const [dataVersion, setDataVersion] = useState<any[]>([]);
  //constant to edit
  const [updateGroupFormInstance] = FormAntd.useForm();
  const [importFormInstance] = FormAntd.useForm();
  const [editIndex, setEditIndex] = useState<IEditIndexItem[]>([]);
  //constant to respone
  const [messageApi, contextHolder] = message.useMessage();
  const { isLocked, runLocked } = useRequestLock();
  const freightCostModalRequestKey = "freight-cost:modal:group-route";
  const freightCostModalPending = isLocked(freightCostModalRequestKey);
  //constant tab
  const [tabItems, setTabItems] = useState<any>([
    { label: "Cước lẻ", key: "1" },
  ]);
  const [activeTabs, setActiveTabs] = useState("1"); //tabs for base
  const [activeTabScreen, setActiveTabScreen] = useState(tabs ?? "0"); //tabs for screen
  const authorizedTabScreen = getAuthorizedFreightCostTab(
    items as Array<{ key: string; disabled?: boolean }>,
    activeTabScreen,
  );
  //constant table base
  const [data, setData] = useState<IFreightCostRow[]>([]);
  const [paginationFreightCost, setPaginationFreightCost] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [filtersByScreenTab, setFiltersByScreenTab] = useState<
    Record<string, Record<string, any>>
  >({
    1: {},
    2: {},
  });
  const filters =
    filtersByScreenTab[activeTabScreen] ?? filtersByScreenTab["1"];
  const [dataGroupContractors, setDataGroupContractor] = useState<
    IFreightCostRow[]
  >([]);
  const [paginationGroupVendor, setPaginationGroupVendor] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const handleFreightCostFiltersChange = useCallback(
    (nextFilters: any) => {
      if (activeTabScreen === "2") {
        setPaginationGroupVendor((prev) =>
          resetPaginationToFirstPage(prev),
        );
      } else {
        setPaginationFreightCost((prev) =>
          resetPaginationToFirstPage(prev),
        );
      }

      setFiltersByScreenTab((prev) => {
        const currentFilters = prev[activeTabScreen] ?? {};
        const resolvedFilters =
          typeof nextFilters === "function"
            ? nextFilters(currentFilters)
            : nextFilters;

        return {
          ...prev,
          [activeTabScreen]: resolvedFilters,
        };
      });
    },
    [activeTabScreen],
  );
  const handleFreightCostScreenTabChange = useCallback(
    (nextTab: string, navigation: "push" | "replace" = "push") => {
      if (nextTab === "2") {
        setPaginationGroupVendor((prev) =>
          resetPaginationToFirstPage(prev),
        );
      } else {
        setPaginationFreightCost((prev) =>
          resetPaginationToFirstPage(prev),
        );
      }
      setActiveTabScreen(nextTab);
      const nextPath = `/common/freight-costs?tabs=${nextTab}`;
      if (navigation === "replace") {
        history.replace(nextPath);
      } else {
        history.push(nextPath);
      }
    },
    [history],
  );
  const handleFreightCostVersionChange = (versionId: string) => {
    setPaginationFreightCost((prev) => resetPaginationToFirstPage(prev));
    setActiveVersion(versionId);
  };
  const refreshFreightCostVersions = async () => {
    const response: any = await FreightCostApi.getFreightVesion({
      state: "VALID",
    });
    const versions = response?.data ?? [];

    setDataVersion(versions);
    setActiveVersion((currentVersion) =>
      currentVersion &&
      versions.some((version: any) => version._id === currentVersion)
        ? currentVersion
        : versions[0]?._id ?? null,
    );
  };
  const handleApplyFreightCostVersion = (record: any) => {
    if (!canApplyFreightVersion(record, canEditFreightCost)) return;

    const affectedOrderCount = getFreightVersionOrderCount(
      record.affectedOrderCount,
    );
    const pendingOrderCount = getFreightVersionOrderCount(
      record.pendingOrderCount,
    );

    confirm({
      title: "Áp dụng giá mới",
      content: (
        <div>
          <div>
            Phiên bản: <strong>{record.name || "-"}</strong>
          </div>
          <div>
            Đơn hàng bị ảnh hưởng: <strong>{affectedOrderCount}</strong>
          </div>
          <div>
            Đơn hàng chưa áp dụng: <strong>{pendingOrderCount}</strong>
          </div>
        </div>
      ),
      okText: "Áp dụng",
      cancelText: "Hủy",
      onOk: async () => {
        await runLocked(`freight-cost:apply-version:${record._id}`, async () => {
          try {
            const response =
              await FreightCostApi.applyFreightCostVersionToOrders(record._id);
            if (response?.success === false) {
              throw new Error(response.message || "Áp dụng giá thất bại");
            }

            messageApi.success(
              response?.message || "Áp dụng giá mới thành công",
            );
            try {
              await refreshFreightCostVersions();
            } catch {
              messageApi.warning(
                "Đã áp dụng giá nhưng chưa tải lại được số lượng đơn hàng",
              );
            }
          } catch (error: any) {
            messageApi.error(error?.message || "Áp dụng giá thất bại");
          }
        });
      },
    });
  };
  const [listVendor, setListVendor] = useState([]);
  //constant for modal
  const [onModalPostion, setOnModalPosition] = useState(false);
  const [
    isUpdateGroupContractorModalOpen,
    setIsUpdateGroupContractorModalOpen,
  ] = useState(false);
  //constant search contractor
  const [valueSearchContractor, setValueSearchContractor] = useState("");
  //constant useWatch
  const routeBaseWatch = FormAntd.useWatch(
    "routeBase",
    updateGroupFormInstance,
  );
  const truckVendorGroupWatch = FormAntd.useWatch(
    "truckVendorGroup",
    updateGroupFormInstance,
  );
  const importSelectedName = FormAntd.useWatch("name", importFormInstance);
  const importOnCopy = FormAntd.useWatch("onCopy", importFormInstance);
  const [openModalImport, setOpenModalImport] = useState(false);
  const canImportFreightCost = checkPermissions(
    "CONTRACTOR_FREIGHT",
    "import",
    features,
  );
  const newObj = {
    id: null,
    groupName: null,
    truckVendors: [],
    status: "new",
  };
  const newObjFreight = {
    _id: null,
    code: null,
    customer: null,
    routeBase: null,
    receiptAddress: null,
    deliveryAddress: null,
    price: null,
    deliveryCost: null,
    extraFee: null,
    validFrom: null,
    customerName: null,
    status: "new",
  };
  const typeDelivery = [
    { label: "BẮC - NAM", value: "ROAD" },
    { label: "CẢNG", value: "EXIM" },
    { label: "BIÊN", value: "BORDER" },
    { label: "ĐƯỜNG THUỶ", value: "WATERWAY" },
    { label: "CHUYỂN KHO", value: "TRANSFER" },
  ];
  const colsBase = [
    {
      title: "#",
      dataIndex: "_id",
      width: 50,
      fixed: "left",
      hidden: false,
      render: (row: any, record: any, index: number) => index + 1,
    },
    {
      title: "Nhà thầu",
      dataIndex: "truckVendorName",
      filterDataIndex: "truckVendor",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "debounce",
        filterProps: {
          showSearch: true,
          fetchOptions: (
            value: string,
            _selectedValue?: string,
            filters: LookupFilters = {},
          ) => {
            return apiDebounceTruckvendor(value, _selectedValue, filters).then(
              (res) => res.data,
            );
          },
          placeholder: "Nhập nhà thầu",
        },
      },
      editType: "LookupTableSelect",
      editProps: (val: any, record: any, editIndex: any) => {
        return {
          ...truckVendorLookupTable,
          disabled: !(record?.status === "new"),
          fetchOptions: (value: string) => {
            return apiDebounceTruckvendor(value).then((res) => res.data);
          },
        };
      },
      colReturn: (row: any) => row?.label ?? row,
    },
    {
      title: "Mã tuyến",
      dataIndex: "code",
      filterDataIndex: "searchText",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "string",
        filterProps: {
          placeholder: "Nhập mã tuyến",
        },
      },
      editType: "LookupTableSelect",
      editProps: (val: any, record: any, editIndex: any) => {
        return {
          ...routeBaseLookupTable,
          fetchOptions: apiDebounceRoute,
          disabled: !(record?.status === "new"),
          onChange: (val: any, dataSource: any) => {
            handleOnChangeRouter(val, record._id, dataSource);
          },
        };
      },
      colReturn: (row: any) => row?.label ?? row,
    },
    {
      title: "Khu vực",
      dataIndex: ["routeBase", "regionName"],
      filterDataIndex: "region",
      importTitle: "Khu vực",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "select",
        filterProps: {
          showSearch: true,
          optionFilterProp: "label",
          options: regionAndDirectionSelectOptions.region,
          placeholder: "Nhập mã tuyến",
        },
      },
      render: (row: any, record: any) => row ?? record?.routeBase?.region?.name,
    },
    {
      title: "Chiều hàng",
      dataIndex: ["routeBase", "direction"],
      filterDataIndex: "direction",
      importTitle: "Chiều hàng",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "select",
        filterProps: {
          showSearch: true,
          optionFilterProp: "label",
          options: regionAndDirectionSelectOptions.direction,
          placeholder: "Nhập mã tuyến",
        },
      },
      render: (row: any, record: any) => row ?? record?.routeBase?.direction,
    },
    {
      title: "Hình thức VC",
      dataIndex: ["routeBase", "roadType"],
      filterDataIndex: "roadType",
      importTitle: "Hình thức vận chuyển",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "select",
        filterProps: {
          showSearch: true,
          optionFilterProp: "label",
          options: typeDelivery,
          placeholder: "Nhập hình thức vận chuyển",
        },
      },
      render: (row: any) =>
        typeDelivery.find((ite) => ite.value === row)?.label,
    },
    {
      title: "Địa điểm",
      dataIndex: "location",
      children: [
        {
          title: "Điểm nhận",
          dataIndex: ["routeBase", "receipt", "address"],
          filterDataIndex: "receipt",
          importTitle: "Địa điểm nhận hàng",
          fixed: false,
          hidden: false,
          filterConfig: {
            type: "string",
            filterProps: {
              // showSearch: true,
              // options: provines,
              // optionFilterProp: "label",
              placeholder: "Nhập điểm nhận",
            },
          },
        },
        {
          title: "Điểm trả",
          dataIndex: ["routeBase", "delivery", "address"],
          filterDataIndex: "delivery",
          importTitle: "Địa điểm trả hàng",
          fixed: false,
          hidden: false,
          filterConfig: {
            type: "string",
            filterProps: {
              // showSearch: true,
              // options: provines,
              // optionFilterProp: "label",
              placeholder: "Nhập điểm trả",
            },
          },
        },
      ],
    },
    {
      title: "KM",
      dataIndex: "routeBase",
      children: [
        {
          title: "Km có hàng",
          dataIndex: ["routeBase", "haveGoodsDistance"],
          importTitle: "Km có hàng",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "Nhập km có hàng",
          //   },
          // },
          render: (row: any) => row ?? 0 + " km",
        },
        {
          title: "Km không hàng",
          dataIndex: ["routeBase", "noGoodsDistance"],
          importTitle: "Km không hàng",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "Nhập km không hàng",
          //   },
          // },
          render: (row: any) => row ?? 0 + " km",
        },
      ],
    },
    {
      title: "Cước vận chuyển",
      dataIndex: "price",
      fixed: false,
      hidden: false,
      // filterConfig: {
      //   type: "number",
      //   filterProps: {
      //     placeholder: "Nhập số tiền",
      //   },
      // },
      children: [
        {
          title: "Cont 20",
          dataIndex: ["price", "cont20"],
          importTitle: "cont20",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "Nhập số tiền",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
        {
          title: "Cont 40",
          dataIndex: ["price", "cont40"],
          importTitle: "cont40",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "Nhập số tiền",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
        {
          title: "Cont 45",
          dataIndex: ["price", "cont45"],
          importTitle: "cont45",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
      ],
    },
    {
      title: "Cước CY",
      dataIndex: "price",
      fixed: false,
      hidden: false,
      children: [
        {
          title: "20",
          dataIndex: ["price", "cy20"],
          importTitle: "cy20",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
        {
          title: "40",
          dataIndex: ["price", "cy40"],
          importTitle: "cy40",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
        {
          title: "45",
          dataIndex: ["price", "cy45"],
          importTitle: "cy45",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
      ],
    },
    {
      title: "Kẹp lệch",
      dataIndex: "price",
      fixed: false,
      hidden: false,
      children: [
        {
          title: "20",
          dataIndex: ["price", "splitCont20"],
          importTitle: "Kẹp lệch",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
      ],
    },
    {
      title: "Phí GN",
      dataIndex: "deliveryCost",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "number",
        filterProps: {
          placeholder: "",
        },
      },
      children: [
        {
          title: "Xuất",
          dataIndex: ["deliveryCost", "export"],
          importTitle: "Phí giao nhận Xuất",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
        {
          title: "Nhập",
          dataIndex: ["deliveryCost", "import"],
          importTitle: "Phí giao nhận Nhập",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
      ],
    },
    {
      title: "Phụ cước",
      dataIndex: "extraFee",
      fixed: false,
      hidden: false,
      filterConfig: {
        type: "number",
        filterProps: {
          placeholder: "",
        },
      },
      children: [
        {
          title: "Xuất",
          dataIndex: ["extraFee", "export"],
          importTitle: "Phụ cước Xuất",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
        {
          title: "Nhập",
          dataIndex: ["extraFee", "import"],
          importTitle: "Phụ cước Nhập",
          fixed: false,
          hidden: false,
          // filterConfig: {
          //   type: "number",
          //   filterProps: {
          //     placeholder: "",
          //   },
          // },
          editType: "InputNumber",
          editProps: {
            formatter: (value: number) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            control: false,
          },
          colReturn: (row: any) => (row?.toLocaleString() ?? 0) + " đ",
        },
      ],
    },
  ];
  const [columns, setColumns] = useState<any>(colsBase);
  const updateGroupContractors: any = getUpdateGroupContractorsConfig({
    apiDebounceRoute,
    routeBaseWatch,
    truckVendorGroupWatch,
  });

  const configInputImportForm: any = getConfigInputImportForm({
    dataVersion,
    formInstance: importFormInstance,
    selectedName: importSelectedName,
    onCopy: importOnCopy,
  });

  const dataSource = useMemo(() => {
    return data;
  }, [data]);
  const applyFreightCostRows = (resDataFreightCost: any) => {
    setData(resDataFreightCost?.data ?? []);
    setPaginationFreightCost((prev) => ({
      ...prev,
      total: resDataFreightCost?.totalItem || 0,
    }));
  };
  const loadFreightCostRows = useCallback(async () => {
    return FreightCostApi.getAllFreight(
      getFreightCostListParams({
        activeTabs,
        activeVersion,
        pagination: {
          current: paginationFreightCost.current,
          pageSize: paginationFreightCost.pageSize,
        },
        filters,
      }),
    );
  }, [
    activeTabs,
    activeVersion,
    filters,
    paginationFreightCost.current,
    paginationFreightCost.pageSize,
  ]);
  // Function to handle action
  const handleOnChangeRouter = async (
    router: any,
    id: string,
    dataSource: any,
  ) => {
    try {
      const detailRouter = await getOneRouter(router.value);
      const detail = detailRouter.data;
      const newDataSource = dataSource.map((ite: any) =>
        ite._id === id ? { ...ite, routeBase: detail, _id: id } : ite,
      );
      setData(newDataSource);
    } catch (error: any) {
      messageApi.error(error?.message || "Không tải được thông tin tuyến");
    }
  };
  const handleActionTable = (action: string, record: any, index: string) => {
    switch (action) {
      case "edit":
        setEditIndex([...editIndex, { index: index, record: { ...record } }]);
        break;
      case "delete":
        confirm({
          title: "Xác nhận xoá",
          content: "Bạn có chắc chắn muốn xoá bản ghi này không?",
          okText: "Xoá",
          cancelText: "Huỷ",
          okType: "danger",
          async onOk() {
            try {
              if (activeTabScreen === "1") {
                await FreightCostApi.shortDeleteFreightCost({
                  ids: [record._id],
                });
                setData((prev: any) =>
                  prev.filter((item: any) => item._id !== record._id),
                );
                setPaginationFreightCost((prev) =>
                  getFreightCostPaginationAfterDelete(prev, 1),
                );
              } else {
                await TruckVendorApi.deleteTruckVendorGroup(index);
                setDataGroupContractor((prev: any) =>
                  prev.filter((item: any) => item._id !== record._id),
                );
                setPaginationGroupVendor((prev) =>
                  getFreightCostPaginationAfterDelete(prev, 1),
                );
              }
              setEditIndex((prev: any[]) =>
                prev.filter((item) => item.index !== index),
              );
            } catch (error: any) {
              messageApi.error(error?.message || "Xoá bản ghi thất bại");
            }
          },
          onCancel() {},
        });
        // tìm index trong data theo id
        break;
      default:
        break;
    }
    // setEditIndex([...editIndex, { index: index, record: record }]);
  };
  const handleActionSaveFreightCost = async (index: any, key: number) => {
    await runLocked(`freight-cost:row:${activeTabs}:${index}`, async () => {
      try {
        const rowEdit = editIndex.find(
          (ind: any) => ind.index === index,
        )?.record;
        if (!rowEdit) {
          messageApi.error("Không tìm thấy dữ liệu cần lưu");
          return;
        }
        const requiredAction = rowEdit.status === "new" ? "add" : "edit";
        if (
          !checkPermissions(
            "CONTRACTOR_FREIGHT",
            requiredAction,
            features,
          )
        ) {
          return;
        }
        const originalRowId = rowEdit._id ?? index;
        // ✅ check NULL các field req
        if (
          hasNullRequiredField(
            rowEdit,
            activeTabs !== "1" ? ["code"] : ["code", "truckVendorName"],
          )
        ) {
          messageApi.error("Không được bỏ trống bất kỳ trường bắt buộc nào");
          return;
        }
        const isNew = rowEdit.status === "new";
        // payload đúng shape API
        const payloadBase = {
          routeBase: getLookupTablePayloadId(rowEdit.code, rowEdit.routeBase),
          versionId: activeVersion ?? "",
          truckVendor: rowEdit.truckVendorName?.value,
          truckVendorGroup: activeTabs !== "1" ? activeTabs : undefined,
        };
        const payloadFreightCost = {
          price: {
            cont20: rowEdit.price?.cont20 ?? 0,
            cont40: rowEdit.price?.cont40 ?? 0,
            cont45: rowEdit.price?.cont45 ?? 0,
            cy20: rowEdit.price?.cy20 ?? 0,
            cy40: rowEdit.price?.cy40 ?? 0,
            cy45: rowEdit.price?.cy45 ?? 0,
            splitCont20: rowEdit.price?.splitCont20 ?? 0,
            truck: rowEdit.price?.truck ?? 0,
          },
          deliveryCost: {
            export: rowEdit.deliveryCost?.export ?? 0,
            import: rowEdit.deliveryCost?.import ?? 0,
          },
          extraFee: {
            export: rowEdit.extraFee?.export ?? 0,
            import: rowEdit.extraFee?.import ?? 0,
          },
        };
        // ===== CALL API =====
        if (isNew) {
          const res = await FreightCostApi.postAddFreightCost(
            {
              ...payloadBase,
              ...payloadFreightCost,
            },
            {
              type:
                activeTabs === "1" ? "TRUCK_VENDOR" : "TRUCK_VENDOR_GROUP",
            },
          );
          // ===== CHỈ KHI API OK =====
          delete rowEdit.status;
          rowEdit._id = res?.data?._id;
        } else {
          await FreightCostApi.putUpdateFreightCost(
            payloadFreightCost,
            rowEdit._id,
            {
              type:
                activeTabs === "1" ? "TRUCK_VENDOR" : "TRUCK_VENDOR_GROUP",
            },
          );
        }
        // // ===== CHỈ KHI API OK =====
        setData((prev) =>
          replaceRowByOriginalId(
            prev,
            originalRowId,
            isNew
              ? {
                  ...rowEdit,
                  routeBase: prev.find(
                    (row: any) => (row._id ?? row.key) === originalRowId,
                  )?.routeBase,
                }
              : rowEdit,
          ),
        );
        setEditIndex((prev: any[]) =>
          prev.filter((ind: any) => ind.index !== index),
        );
      } catch (err: any) {
        messageApi.error(err?.message || "Lưu thất bại");
      }
    });
  };
  const handleActionSaveGroup = async (index: any, key: number) => {
    await runLocked(`freight-cost:group:${index}`, async () => {
      try {
        const rowEdit = editIndex.find(
          (ind: any) => ind.index === index,
        )?.record;
        if (!rowEdit) {
          messageApi.error("Không tìm thấy dữ liệu cần lưu");
          return;
        }
        const requiredAction = rowEdit.status === "new" ? "add" : "edit";
        if (
          !checkPermissions(
            "CONTRACTOR_FREIGHT_GROUP",
            requiredAction,
            features,
          )
        ) {
          return;
        }
        const originalRowId = rowEdit._id ?? index;
        // ✅ check NULL các field req
        if (hasNullRequiredField(rowEdit, REQUIRED_FIELDS_GROUP)) {
          messageApi.error("Không được bỏ trống bất kỳ trường bắt buộc nào");
          return;
        }
        const isNew = rowEdit.status === "new";
        // payload đúng shape API
        const payloadGroup = {
          groupName: rowEdit.groupName,
          listTruckVendors:
            rowEdit.truckVendors?.map((ie: any) => ie.value ?? ie._id) ?? [],
        };
        // ===== CALL API =====
        if (isNew) {
          const res =
            await TruckVendorApi.postCreateTruckVendorGroup(payloadGroup);
          // ===== CHỈ KHI API OK =====
          delete rowEdit.status;
          rowEdit._id = res?.data?._id;
        } else {
          await TruckVendorApi.putUpdateTruckVendorGroup(
            payloadGroup,
            rowEdit._id,
          );
        }
        // ===== CHỈ KHI API OK =====
        setDataGroupContractor((prev) =>
          replaceRowByOriginalId(
            prev,
            originalRowId,
            isNew
              ? {
                  ...rowEdit,
                  routeBase: prev.find(
                    (row: any) => (row._id ?? row.key) === originalRowId,
                  )?.routeBase,
                }
              : rowEdit,
          ),
        );
        setEditIndex((prev: any[]) =>
          prev.filter((ind: any) => ind.index !== index),
        );
      } catch (err: any) {
        messageApi.error(err?.message || "Lưu thất bại");
      }
    });
  };
  const handleActionCancel = (index: string | number) => {
    if (activeTabScreen === "1") {
      const { nextRows, nextEditIndex } = getFreightCostCancelResult(
        data,
        editIndex,
        index,
      );
      setData(nextRows as IFreightCostRow[]);
      setEditIndex(nextEditIndex as IEditIndexItem[]);
      return;
    }

    const { nextRows, nextEditIndex } = getFreightCostCancelResult(
      dataGroupContractors,
      editIndex,
      index,
    );
    setDataGroupContractor(nextRows as IFreightCostRow[]);
    setEditIndex(nextEditIndex as IEditIndexItem[]);
  };
  const handleUpdateRow = (
    key: string,
    value: string,
    index: string | number,
  ) => {
    setEditIndex((prev: any[]) => {
      const newEdit = [...prev];
      const findInd = newEdit.findIndex((item: any) => item.index === index);
      if (findInd === -1) return prev;
      const row = { ...newEdit[findInd] };
      const record = { ...(row.record || {}) };
      const path = toPath(key);
      const touchedKey = normalizeTouchedKey(key);
      // ✅ set nested field
      row.record = setDeepImmutable(record, path, value);
      // ✅ đánh dấu touched
      row.touchedFields = { ...(row.touchedFields || {}), [touchedKey]: true };
      newEdit[findInd] = row;
      return newEdit;
    });
  };
  const handleOnChangePosition = (
    dataIndex: string,
    value: boolean | "left" | "right",
    type: "hidden" | "fixed",
  ) => {
    setColumns(updateColumnDisplayState(columns, dataIndex, value, type));
  };
  const handleAddRow = () => {
    const feature =
      activeTabScreen === "1"
        ? "CONTRACTOR_FREIGHT"
        : "CONTRACTOR_FREIGHT_GROUP";
    if (!checkPermissions(feature, "add", features)) return;

    const checkObjTabs = activeTabScreen === "1" ? newObjFreight : newObj;
    const draftId = `create-${new Date().toISOString()}`;
    const newAddObj: any = { ...checkObjTabs, _id: draftId };
    activeTabScreen === "1"
      ? setData([newAddObj, ...data])
      : setDataGroupContractor([newAddObj, ...dataGroupContractors]);
    setEditIndex([
      ...editIndex,
      {
        index: draftId,
        record: newAddObj,
      },
    ]);
  };
  // Function to render
  const renderModalPosition = () => {
    return (
      <Modal
        open={onModalPostion}
        className={styles.Modal}
        width={"70%"}
        onCancel={() => {
          setOnModalPosition(false);
        }}
        title="Hiển thị cột"
        bodyProps={{
          className: styles.ModalBody,
        }}
        footer={false}
      >
        <Row>
          <Col span={16}>Tên cột</Col>
          <Col span={4}>Hiển thị</Col>
          <Col span={4}>Cố định(trái, phải)</Col>
        </Row>
        <Divider />
        {columns?.map((col: any, key: number) => {
          return (
            <div key={key}>
              <Row>
                <Col span={16}>{col.title}</Col>
                <Col span={4}>
                  <Checkbox
                    checked={!col.hidden}
                    onChange={(e) => {
                      handleOnChangePosition(
                        col.dataIndex,
                        e.target.checked,
                        "hidden",
                      );
                    }}
                  />
                </Col>
                <Col span={4}>
                  <Checkbox
                    checked={col.fixed === "left" ? true : false}
                    onChange={(e) => {
                      handleOnChangePosition(
                        col.dataIndex,
                        e.target.checked && "left",
                        "fixed",
                      );
                    }}
                    style={{ marginRight: "20px" }}
                  />
                  <Checkbox
                    checked={col.fixed === "right" ? true : false}
                    onChange={(e) => {
                      handleOnChangePosition(
                        col.dataIndex,
                        e.target.checked && "right",
                        "fixed",
                      );
                    }}
                  />
                </Col>
              </Row>
              <Divider />
            </div>
          );
        })}
      </Modal>
    );
  };
  //Group Freight Cost
  const handleChangeFreightBaseTab = (tab: string) => {
    setPaginationFreightCost((prev) => resetPaginationToFirstPage(prev));
    setActiveTabs(tab);
    setColumns((prev: any) =>
      updateFreightCostColumnByDataIndex(prev, "truckVendorName", {
        hidden: tab !== "1",
      }),
    );
    const selectedTab = tabItems.find((ite: any) => ite.key === tab);
    if (tab !== "1") {
      setListVendor(selectedTab?.truckVendors ?? []);
    } else {
      setListVendor([]);
    }
  };
  const handleActionSaveFreightCostModal = async () => {
    if (
      !checkPermissions(
        "CONTRACTOR_FREIGHT",
        "add",
        features,
      )
    ) {
      return;
    }

    await runLocked(freightCostModalRequestKey, async () => {
      try {
          // ✅ check NULL các field req
          await updateGroupFormInstance.validateFields();
          const valForm = updateGroupFormInstance.getFieldsValue();
          // payload đúng shape API
          const payloadBase = {
            routeBase: getLookupTablePayloadId(valForm.routeBase),
            versionId: activeVersion ?? "",
            truckVendorGroup: valForm.truckVendorGroup?.value,
          };
          let respone: any = {};
          const payloadFreightCost = {
            price: {
              cont20: valForm.cont20 ?? 0,
              cont40: valForm.cont40 ?? 0,
              cont45: valForm.cont45 ?? 0,
              cy20: valForm.cy20 ?? 0,
              cy40: valForm.cy40 ?? 0,
              cy45: valForm.cy45 ?? 0,
              splitCont20: valForm.splitCont20 ?? 0,
            },
            deliveryCost: {
              export: valForm.deliveryCostExport ?? 0,
              import: valForm.deliveryCostImport ?? 0,
            },
            extraFee: {
              export: valForm.extraFeeExport ?? 0,
              import: valForm.extraFeeImport ?? 0,
            },
          };
          // ===== CALL API =====
          respone = await FreightCostApi.postAddFreightCost(
            {
              ...payloadBase,
              ...payloadFreightCost,
            },
            {
              type: "TRUCK_VENDOR_GROUP",
            },
          );
          if (respone.success) {
            const refreshedFreightCosts = await loadFreightCostRows();
            applyFreightCostRows(refreshedFreightCosts);
            updateGroupFormInstance.resetFields();
            setIsUpdateGroupContractorModalOpen(false);
          }
          // // ===== CHỈ KHI API OK =====
      } catch (err: any) {
        messageApi.error(err?.message || "Lưu thất bại");
      }
    });
  };
  const handleOnShortDeleted = () => {
    confirm({
      title: "Xác nhận xoá",
      content: `Bạn có chắc chắn muốn xoá ${selectedRowKeys.length} bản ghi đã chọn không?`,
      okText: "Xoá",
      cancelText: "Huỷ",
      okType: "danger",
      onOk() {
        // Call API xoá nhiều
        FreightCostApi.shortDeleteFreightCost({
          ids: selectedRowKeys as string[],
        })
          .then(() => {
            setData((prev: any) =>
              prev.filter((item: any) => !selectedRowKeys.includes(item._id)),
            );
            setPaginationFreightCost((prev) =>
              getFreightCostPaginationAfterDelete(prev, selectedRowKeys.length),
            );
            setSelectedRowKeys([]);
          })
          .catch((error) => {
            messageApi.error(
              error?.message || "Xoá bản ghi thất bại, vui lòng thử lại",
            );
          });
      },
      onCancel() {
        setSelectedRowKeys([]);
      },
    });
  };
  //Fregith Costs
  const renderModalUpdateGroupContractors = () => {
    return (
      <Modal
        open={isUpdateGroupContractorModalOpen}
        className={styles.Modal}
        width={"40%"}
        confirmLoading={freightCostModalPending}
        okButtonProps={{
          disabled:
            freightCostModalPending ||
            !checkPermissions(
              "CONTRACTOR_FREIGHT",
              "add",
              features,
            ),
        }}
        cancelButtonProps={{ disabled: freightCostModalPending }}
        closable={!freightCostModalPending}
        maskClosable={!freightCostModalPending}
        keyboard={!freightCostModalPending}
        onCancel={() => {
          if (freightCostModalPending) return;
          setIsUpdateGroupContractorModalOpen(false);
          updateGroupFormInstance.resetFields();
        }}
        onOk={async () => {
          await handleActionSaveFreightCostModal();
        }}
        title="Cập nhật giá theo tuyến"
        bodyProps={{
          className: styles.ModalBody,
        }}
        // footer={false}
      >
        <div style={{ padding: "15px" }}>
          <Form form={updateGroupFormInstance} {...updateGroupContractors} />
        </div>
      </Modal>
    );
  };
  const rightRef = useRef<HTMLDivElement | null>(null);
  const [rightH, setRightH] = useState<number>();
  //Funtion to effect
  useEffect(() => {
    if (canImportFreightCost) return;
    if (!openModalImport) return;

    setOpenModalImport(false);
    importFormInstance.resetFields();
  }, [
    canImportFreightCost,
    importFormInstance,
    openModalImport,
  ]);
  useEffect(() => {
    let mounted = true;

    const fetchLookups = async () => {
      try {
        const [regions, direction]: any = await Promise.all([
          getPermissionRegions({}),
          getPermissionDirections({}),
        ]);

        if (!mounted) return;

        setRegionAndDirectionSelectOptions({
          region:
            regions?.map((region: any) => ({
              label: region.name,
              value: region._id,
            })) || [],
          direction:
            direction?.map((dir: any) => ({
              label: dir.name,
              value: dir.code,
            })) || [],
        });
      } catch (error: any) {
        if (mounted) {
          messageApi.error(error?.message || "Tải danh mục thất bại");
        }
      }
    };

    fetchLookups();

    return () => {
      mounted = false;
    };
  }, [messageApi]);
  useEffect(() => {
    if (!rightRef.current) return;
    const ro = new ResizeObserver(() => {
      const h = rightRef.current?.getBoundingClientRect().height;
      if (h) setRightH(Math.round(h));
    });
    ro.observe(rightRef.current);
    return () => ro.disconnect();
  }, []);
  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      try {
        const resDataVersion: any = await FreightCostApi.getFreightVesion({
          state: "VALID",
        });
        const firstRenderVersion = resDataVersion?.data[0]?._id ?? "";
        const resGroups: any = await TruckVendorApi.getAllTruckVendorGroup({
          current: 1,
          pageSize: 100,
        });
        const data =
          resGroups.data?.length > 0
            ? resGroups.data.map((it: any) => ({
                ...it,
                label: it.groupName,
              }))
            : [];

        if (mounted) {
          setDataVersion(resDataVersion?.data ?? []);
          setActiveVersion(firstRenderVersion);
          setTabItems((prev: any[]) => [prev[0], ...data]);
        }
      } catch (error: any) {
        if (mounted) {
          messageApi.error(error?.message || "Tải phiên bản thất bại");
        }
      }
    };
    fetchData();
    return () => {
      mounted = false;
    };
  }, [messageApi]);
  useEffect(() => {
    let mounted = true;
    const fetchData = async () => {
      try {
        if (mounted && features) {
          if (activeTabScreen === "1") {
            const resDataFreightCost: any = await loadFreightCostRows();
            if (!mounted) return;
            applyFreightCostRows(resDataFreightCost);
          } else if (activeTabScreen === "2") {
            const resGroups: any = await TruckVendorApi.getAllTruckVendorGroup({
              current: paginationGroupVendor.current,
              pageSize: paginationGroupVendor.pageSize,
              ...filters,
            });
            if (!mounted) return;

            setDataGroupContractor(resGroups?.data ?? []);
            setPaginationGroupVendor((prev) => ({
              ...prev,
              total: resGroups?.totalItem || 0,
            }));
          }
        }
      } catch (error: any) {
        if (mounted) {
          messageApi.error(error?.message || "Tải dữ liệu thất bại");
        }
      }
    };
    fetchData();
    return () => {
      mounted = false;
    };
  }, [
    filters,
    activeTabs,
    activeVersion,
    paginationFreightCost.current,
    paginationFreightCost.pageSize,
    paginationGroupVendor.current,
    paginationGroupVendor.pageSize,
    activeTabScreen,
    features,
    loadFreightCostRows,
    messageApi,
  ]);
  useEffect(() => {
    setColumns((prev: any) =>
      mergeFreightCostColumnsWithCurrentState(prev, colsBase),
    );
  }, [regionAndDirectionSelectOptions]);
  useEffect(() => {
    if (
      !features ||
      !authorizedTabScreen ||
      activeTabScreen === authorizedTabScreen
    ) {
      return;
    }

    handleFreightCostScreenTabChange(authorizedTabScreen, "replace");
  }, [
    activeTabScreen,
    authorizedTabScreen,
    features,
    handleFreightCostScreenTabChange,
  ]);
  const headerButtons: HeaderTableProps["buttons"] = [
    {
      children: "Cài đặt hiển thị",
      icon: <Setting />,
      onClick: () => {
        setOnModalPosition(true);
      },
      type: "primary",
    },
    ...(activeTabScreen === "1"
      ? [
          {
            children: "Mẫu import",
            icon: <img src="/icon/xlsx.svg" />,
            onClick: () => {
              if (
                !checkPermissions(
                  "CONTRACTOR_FREIGHT",
                  "export",
                  features,
                )
              ) {
                return;
              }
              CommonApi.getDownloadTemplate("freight", "Cước thầu phụ.xlsx");
            },
            type: "primary" as const,
            disabled: !checkPermissions(
              "CONTRACTOR_FREIGHT",
              "export",
              features,
            ),
          },
          {
            children: "Import giá cước",
            icon: <img src="/icon/xlsx.svg" />,
            onClick: () => {
              if (!canImportFreightCost) return;
              setOpenModalImport(true);
            },
            style: {
              backgroundColor: checkPermissions(
                "CONTRACTOR_FREIGHT",
                "import",
                features,
              )
                ? "#00529F"
                : "#C0C0C0",
            },
            disabled: !checkPermissions(
              "CONTRACTOR_FREIGHT",
              "import",
              features,
            ),
          },
          {
            children: "Thêm giá cho tuyến mới",
            onClick: () => {
              setIsUpdateGroupContractorModalOpen(true);
              const curVersion: any =
                dataVersion?.length > 0 &&
                dataVersion.find((ite: any) => ite._id === activeVersion);
              updateGroupFormInstance.setFieldsValue({
                version: curVersion?.name,
                versionValidFrom: dayjs(curVersion?.validFrom).format(
                  "DD/MM/YYYY",
                ),
              });
            },
            style: {
              backgroundColor: checkPermissions(
                "CONTRACTOR_FREIGHT",
                "add",
                features,
              )
                ? "#00529F"
                : "#C0C0C0",
            },
            disabled: !checkPermissions("CONTRACTOR_FREIGHT", "add", features),
          },
        ]
      : []),
  ];
  // Main render
  return (
    <PermissionDirect
      screen={["CONTRACTOR_FREIGHT", "CONTRACTOR_FREIGHT_GROUP"]}
    >
      <div className={styles.FreightCosts}>
        {contextHolder}
        <div style={{ paddingLeft: "10px" }}>
          <Tabs
            items={items}
            activeKey={activeTabScreen}
            onChange={(tab) => {
              const nextTab = getAuthorizedFreightCostTab(
                items as Array<{ key: string; disabled?: boolean }>,
                tab,
              );
              if (!nextTab) return;
              handleFreightCostScreenTabChange(nextTab);
            }}
          />
        </div>
        <div className="container">
          <HeaderTable
            title={
              activeTabScreen === "1" ? "Cước thầu phụ" : "Nhóm cước thầu phụ"
            }
            buttons={headerButtons}
          />
          {activeTabScreen === "1" ? (
            <FreightCostListTab
              activeTabs={activeTabs}
              activeVersion={activeVersion}
              columns={columns}
              dataSource={dataSource}
              dataVersion={dataVersion}
              editIndex={editIndex}
              features={features}
              filters={filters}
              listVendor={listVendor}
              onAddRow={handleAddRow}
              onActionCancel={handleActionCancel}
              onActionSaveFreightCost={handleActionSaveFreightCost}
              isSavePending={(rowId) => isLocked(`freight-cost:row:${activeTabs}:${rowId}`)}
              isVersionApplyPending={(versionId) =>
                isLocked(`freight-cost:apply-version:${versionId}`)
              }
              onActionTable={handleActionTable}
              onApplyVersion={handleApplyFreightCostVersion}
              onBulkDelete={handleOnShortDeleted}
              onChangeActiveTabs={handleChangeFreightBaseTab}
              onExportVersion={(id, name) => {
                if (
                  !checkPermissions(
                    "CONTRACTOR_FREIGHT",
                    "export",
                    features,
                  )
                ) {
                  return;
                }
                FreightCostApi.getExportVersion(id, name);
              }}
              onGoToGroup={() => {
                const nextTab = getAuthorizedFreightCostTab(
                  items as Array<{ key: string; disabled?: boolean }>,
                  "2",
                );
                if (!nextTab) return;
                handleFreightCostScreenTabChange(nextTab);
              }}
              onPaginationChange={(page, pageSize) => {
                setPaginationFreightCost((prev) => ({
                  ...prev,
                  current: page,
                  pageSize: pageSize || prev.pageSize,
                }));
              }}
              onRowSelectionChange={(selectedKeys) => {
                setSelectedRowKeys(selectedKeys);
              }}
              onSearchContractorChange={(value: string) => {
                setValueSearchContractor(value);
              }}
              onSetActiveVersion={(id) => {
                handleFreightCostVersionChange(id);
              }}
              pagination={paginationFreightCost}
              rightContainerRef={rightRef}
              rightHeight={rightH}
              selectedRowKeys={selectedRowKeys}
              setFilters={handleFreightCostFiltersChange}
              tabItems={tabItems}
              valueSearchContractor={valueSearchContractor}
              onUpdateRow={handleUpdateRow}
            />
          ) : (
            <FreightCostGroupTab
              dataSource={dataGroupContractors}
              editIndex={editIndex}
              features={features}
              fetchTruckVendorOptions={(value: string) =>
                apiDebounceTruckvendor(value).then((res) => res.data)
              }
              filters={filters}
              onAddRow={handleAddRow}
              onActionCancel={handleActionCancel}
              onActionSaveGroup={handleActionSaveGroup}
              isSavePending={(rowId) => isLocked(`freight-cost:group:${rowId}`)}
              onActionTable={handleActionTable}
              onPaginationChange={(page, pageSize) => {
                setPaginationGroupVendor((prev) => ({
                  ...prev,
                  current: page,
                  pageSize: pageSize || prev.pageSize,
                }));
              }}
              onUpdateRow={handleUpdateRow}
              pagination={paginationGroupVendor}
              setFilters={handleFreightCostFiltersChange}
            />
          )}
        </div>
        <ModalImport
          columns={columns}
          open={openModalImport}
          onCancel={() => {
            setOpenModalImport(false);
            importFormInstance.resetFields();
          }}
          precheckApi={async (file: Blob) => {
            if (!canImportFreightCost) {
              throw new Error("Bạn không có quyền import cước thầu phụ");
            }
            return FreightCostApi.postPreCheckImportFreight(file);
          }}
          confirmApi={(payload) => {
            if (!canImportFreightCost) {
              return Promise.reject(
                new Error("Bạn không có quyền import cước thầu phụ"),
              );
            }
            return importFormInstance.validateFields().then(() => {
              const val = importFormInstance.getFieldsValue([
                "validFrom",
                "name",
                "onCopy",
                "cloneFromVersion",
              ]);
              return FreightCostApi.postConfirmImportFreight({
                ...payload,
                versionId: val.name === "new" ? payload.versionId : val.name,
                validFrom: dayjs(val.validFrom).toISOString(),
                cloneFromVersion: val.onCopy ? val.cloneFromVersion : undefined,
              }).then(() => {
                importFormInstance.resetFields();
              });
            });
          }}
        >
          <Form form={importFormInstance} {...configInputImportForm} />
        </ModalImport>
        {renderModalPosition()}
        {renderModalUpdateGroupContractors()}
      </div>
    </PermissionDirect>
  );
};
export { FreightCosts };
